import BaseDataObject from './BaseDataObject';
import Track from './Track';

export default class BetKeyInfo extends BaseDataObject {
  getTime() {
    return this.getFirstRacePostTime()
      ? this.getFirstRacePostTime()
      : this.getFirstPostTimePerBetType();
  }

  getFirstRacePostTime() {
    return this.getDate('firstRacePostTime');
  }

  getFirstPostTimePerBetType() {
    return this.data.firstPostTimePerBetType;
  }

  setFirstPostTimePerBetType(v) {
    this.data.firstPostTimePerBetType = v;
  }

  getTimePerRaceNumber() {
    return this.data.postTimePerRaceNr || {};
  }

  setTimePerRaceNumber(v) {
    this.data.postTimePerRaceNr = v;
  }

  getTrack() {
    return this.getObject('track', Track);
  }

  setTrack(v) {
    return this.setObject('track', v);
  }

  getRaceNumbers() {
    return this.getIntegerArray('raceNrs');
  }

  setRaceNumbers(v) {
    return this.setIntegerArray('raceNrs', v);
  }

  getRikstotoTrackCode() {
    return this.getString('rikstotoForeignTrackCode');
  }

  allowsAllIn() {
    return this.getBoolean('allowsAllIn');
  }
}
